import * as THREE from "three";

// Emissive window-grid texture for skyscrapers (lit windows against dark glass).
export function makeWindowTexture(cols = 6, rows = 16) {
  const cell = 16;
  const c = document.createElement("canvas");
  c.width = cols * cell;
  c.height = rows * cell;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#060a14";
  ctx.fillRect(0, 0, c.width, c.height);
  const palette = ["#ffd9a0", "#bfe3ff", "#ffe8c2", "#9fd0ff"];
  for (let y = 0; y < rows; y++) {
    for (let x = 0; x < cols; x++) {
      const lit = Math.random() > 0.35;
      ctx.fillStyle = lit ? palette[Math.floor(Math.random() * palette.length)] : "#0b1220";
      const pad = 3;
      ctx.fillRect(x * cell + pad, y * cell + pad, cell - pad * 2, cell - pad * 2);
    }
  }
  const tex = new THREE.CanvasTexture(c);
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}
